<template>
  <AppSection
    id="question-form-page"
    :title="$getConst.pages.email_template_configuration.email_template_page_title"
    type="section"
    select-language
    :is-section-loading="is_loading"
  >

    <b-row class="justify-content-center py-5">

      <template v-for="option in options">
        <b-col v-if="!is_loading && option.is_shown" xl="3" lg="4" md="4" sm="6" class="pb-4">
          <AppPageOptionBox
            @onClick="onSelectOption(option)" :text="option.text" :icon="option.icon"/>
        </b-col>
      </template>

    </b-row>

  </AppSection>
</template>

<script>
  import AppSection from "../../../../../components/common/sections/AppSection";
  import AppPageOptionBox from "../../../../../components/common/utils/AppPageOptionBox";
  import {getOneScope} from "../../../../../api/scopes.api";

  export default {
    name: "index",
    components: {AppPageOptionBox, AppSection},
    props: {
      scope_id: null
    },
    data() {
      return {
        is_loading: false,
        scope: null
      }
    },
    computed: {
      options() {
        if (!this.is_loading) {
          return [
            {
              destination: "GENERAL",
              text: this.$t(this.$getConst.pages.email_template_configuration.general_email_templates),
              icon:this.$getConst.svgIcons.envelope_open_text,
              is_shown: true
            },
            {
              destination: "TIMESHEETS",
              text: this.$t(this.$getConst.pages.email_template_configuration.timesheets_email_templates),
              icon:this.$getConst.svgIcons.timesheets_email_templates,
              is_shown: this.scope.is_timesheets_enabled
            },
            {
              destination: "INVOICES",
              text: this.$t(this.$getConst.pages.email_template_configuration.invoices_email_templates),
              icon:this.$getConst.svgIcons.invoices_email_templates,
              is_shown: this.scope.is_invoices_enabled
            },
          ];
        }
      }
    },
    methods: {
      getScope() {
        this.is_loading = true;
        getOneScope(this.scope_id).then(
          response => {
            this.scope = response.data;
            this.is_loading = false;
          },
          error => {
            this.handleApiError(error);
            this.is_loading = false;
          }
        )
      },
      onSelectOption(option) {
        switch (option.destination) {
          case "GENERAL":
            this.$router.push({name: this.$getConst.routesNames.administration.editEmailTemplates, params: {type: 'general'} });
            break;
          case "TIMESHEETS":
            this.$router.push({name: this.$getConst.routesNames.administration.editEmailTemplates, params: {type: 'timesheets'}});
            break;
          case "INVOICES":
            this.$router.push({name: this.$getConst.routesNames.administration.editEmailTemplates, params: {type: 'invoices'}});
            break;
          default:
            break;
        }
      }
    },
    created() {
      this.getScope();
    }
  }
</script>

<style scoped>

</style>
